import { colors } from '@/styles/theme/foundations/colors';
import { radii } from '@/styles/theme/foundations/radius';
import { space } from '@/styles/theme/foundations/space';

export const formContaier = {
  flexDirection: 'column' as const,
  alignItems: 'flex-start',
  padding: space[6],
  width: '100%',
  background: colors.background.nestedContainer.dark,
  borderRadius: radii.lg,
  marginTop: space[6],
  marginBottom: space[4],
  overflow: 'hidden',
};
